import ProductsSearchAutocomplete from './ProductsSearchAutocomplete'

export default ProductsSearchAutocomplete
